<template>
  <base-spinner :open="isloading"></base-spinner>
  <div class="card-cart-total">
    <div class="card-body card-body--padding--slim">
      <div class="card-title-order-entry-absolute">
        <h3 class="card-title-order-entry">Cart Totals</h3>
      </div>
      <table class="cart__totals-table">
        <thead>
          <tr>
            <th>Subtotal</th>
            <td class='notranslate'>{{ toUSD(totals[0].subtotal) }}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-if="this.customerIndicator === 'B' && totals[0].backordered_total > 0">
            <th>Backorder</th>
            <td class='notranslate'>{{ toUSD(totals[0].backordered_total) }}</td>
          </tr>
          <tr v-if="totals[0].coretotal > 0">
            <th>Core</th>
            <td class='notranslate'>{{ toUSD(totals[0].coretotal) }}</td>
          </tr>
          <tr v-if="this.customerIndicator === 'C' && totals[0].taxtotal > 0">
            <th>Est. Tax</th>
            <td class='notranslate'>{{ toUSD(totals[0].taxtotal) }}</td>
          </tr>
          <tr v-if="totals[0].shippingtotal > 0">
            <th>Est. Shipping</th>
            <td class='notranslate'>{{ toUSD(totals[0].shippingtotal) }}</td>
          </tr>
          <tr v-if="totals[0].discounttotal > 0">
              <th>Promotional Discount:</th>
              <td class='notranslate'>- {{toUSD(totals[0].discounttotal)}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>Total</th>
            <td class='notranslate'>{{ toUSD(totals[0].ordertotal) }}</td>
          </tr>
        </tfoot>
      </table>
      <div class="card-cart-toal-column center-elements-text">
        <div class="form-group mb-0 col-auto">
          <!--<button type="button" class="btn btn-sm btn-grey">Edit Order</button>-->
          <!-- <button type="button" class="btn btn-sm btn-primary" v-if="userIsAuthenticated" @click="saveOrder">
            Save Order
          </button> -->
          <router-link class="btn btn-sm btn-checkout" :to="checkoutLink">Check Out</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import Price from '../../../mixins/price.js';
import { mapGetters } from 'vuex';

export default {
    mixins: [Price],
    data() {
      return {
        servermessages: [],
        serverstatus: "",
        isloading: false,
      }
    },
    methods: {
      saveOrder() {
        this.isloading = true;
        let parts = [];

        this.cart.forEach(cartitem => {
          parts.push([
            cartitem.manufacturer, 
            cartitem.item,
            cartitem.quantity,
            "",
            ""
          ]);
        });

        axiosvl.post(this.$store.getters['api/add_saved_order_uri'], {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },
                  "fields": {
                      "EHCUST": {"value": this.$store.getters.customer},
                      "EHPONO": {"value": "TEST PO - LANSA"},
                      "EHCARR": {"value": " "}
                  },
                  "lists": {
                        "PARTSO": {
                            "header": [
                                {"name": "EKMFGC"},
                                {"name": "EKITMC"},
                                {"name": "EKOQTY"},
                                {"name": "EKCPO#"},
                                {"name": "EKLOCN"}
                            ],
                            "entries": parts
                        }
                    }
              }
            }
        )
        .then((response) => {
            const fields = response.data.webroutine.fields
            if (fields.RESULTCOD.value === 'OK') {
              this.servermessages.push("Your order has been saved successfully.");
            } else {
              const messages = [];
              const wrmessages = response.data.webroutine.messages;

              for (var i = 0; i < wrmessages.length; i++) {
                messages.push(wrmessages[i]);
              }

              // Return code is not "OK" but no messages appear, add a custom error message
              if (messages.length === 0) {
                messages.push("Something went wrong. Please try again later.");
              }
 
              this.servermessages = messages;
            }

            // !NC!
            if (this.servermessages.length > 0) {
              this.servermessages.forEach(message => {
                alert(message);
              });
            }

            this.isloading = false;
        })
        .catch((error) => {
          this.isloading = false;
            console.log("error - " + error);
        });
      },
    },
    computed: {
        checkoutLink() {
          return this.customerIndicator === 'B' ? '/checkout-business' : '/checkout';
        },
        ...mapGetters([
          'userIsAuthenticated',
          'customerIndicator'
        ]),
        ...mapGetters("cart", [
            "cart",
            "totals"
        ])
    }
}
</script>